export const local = state => {
  return state.local;
};

export const getIPInfoTest = state => {
  return state.IPInfoTest + 1;
};
export const category = state => {
  return state.category;
};
export const freez = state => {
  return state.freez;
};
export const detail = state => {
  return state.productDetail;
};
export const historyPrice = state => {
  return state.historyPrice;
};
export const categoryTreeCopy = state => {
  let tree = state.CategoryTree.map(item => {
    if (item.sons.length > 0) {
      item.sons.map(item1 => {
        if (item1.sons.length > 0) {
          item1.sons = [];
        }
        return item1;
      });
    }
    return item;
  });
  console.log("CategoryTree", state.CategoryTree);
  console.log("tree", tree);
  return tree;
};



// WEBPACK FOOTER //
// ./src/store/getters.js